import { useState } from "react";
import { GetAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";
type TSearchFields = {
  name: string;
  email: string;
  companyId: string;
  search: string;
  page: number;
  record: number;
};

const useItem = ({
  label = "",
  value = "",
  vendorId = "",
  customerId = "",
}: {
  label: string;
  value: string;
  vendorId?: string;
  customerId?: string;
}) => {
  const [options, setOptions] = useState<any[]>([]);
  const [searchFields, setSearchFields] = useState({
    page: 1,
    record: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [optionErrorMsg, setOptionErrorMsg] = useState("");
  const [selectOption, setSelectOption] = useState<any>({
    label: label,
    value: value,
  });
  const onOpen = () => {
    getAsyncOptions();
  };

  const getAsyncOptions = async (searchField_?: Partial<TSearchFields>) => {
    let searchField = {
      ...searchFields,
      ...searchField_,
    };
    setLoading(true);
    GetAsync(
      `${API_GATEWAY}/api/catalogService/Items/${
        vendorId ? "vendorItems" : "customerItems"
      }`,
      true,
      undefined,
      {
        params: {
          page: searchField.page || undefined,
          record: searchField.record || undefined,
          searchvalue: searchField.search || undefined,
          vendorId: vendorId || undefined,
          customerId: customerId || undefined,
        },
      },
    )
      .then((res) => {
        if (res.status === 200) {
          let options: { name: string; code: string; price: number | null }[] =
            [];
          res?.data?.items?.forEach((item: any) => {
            let price = null;
            if (item?.itemVariations?.length > 0) {
              price = item?.itemVariations[0]?.price;
            } else {
              price = item?.price;
            }

            options.push({
              name: item?.name,
              code: item?.code,
              price: price,
            });
          });
          setOptions(options);
          setTotalCount(res?.data?.totalFilteredRecords);
          if (optionErrorMsg !== "") {
            setOptionErrorMsg("");
          }
        } else if (res.status === 400) {
          setOptionErrorMsg(res.data.Detail);
          if (options?.length > 0) {
            setOptions([]);
          }
        } else {
          if (options?.length > 0) {
            setOptions([]);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return {
    options,
    selectOption,
    setSelectOption,
    getAsyncOptions,
    totalCount,
    loading,
    searchFields,
    optionErrorMsg,
    onOpen,
  };
};
export default useItem;
